import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import Slide from './SlickCarousel';
import AccountsStore from '../../../stores/AccountsStore';
import FinancialStoriesActionCreator from '../../../actions/FinancialStoriesActionCreator';
import SavingsPotsStore from '../../../stores/SavingsPotsStore';
import NumberUtils from '../../../utils/NumberUtils';
import FinancialStoriesStore from '../../../stores/FinancialStoriesStore';
import FinancialStoriesBL from './FinancialStoriesBL';
import SavingPotsActionCreator from '../../../actions/SavingPotsActionCreator';
import ErrorPopUpComponent from '../../common/ErrorPopUpComponent';
import ProjectionStore from '../../../stores/ProjectionStore';
import { isVM } from '../../../utils/BrandUtils';

class FinancialStoriesComponent extends React.Component {
  constructor(props) {
    super(props);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.onTileClick = this.onTileClick.bind(this);
    this.onProjectionStoreChange = this.onProjectionStoreChange.bind(this);
    this.state = {
      tiles: FinancialStoriesBL.getTiles(
        AccountsStore.getAccountDetail(this.props.account)
      ),
      showError: FinancialStoriesStore.getErrorFlag(),
      projectionStatus: ProjectionStore.getStatusOfId(this.props.account),
    };
  }
  componentWillMount() {
    this.state.tiles.length > 1 &&
      FinancialStoriesActionCreator.getFSConnection(this.props.account);
    FinancialStoriesStore.addChangeListener(this.onStoreChange);
    ProjectionStore.addChangeListener(this.onProjectionStoreChange);
  }
  componentWillReceiveProps(nextprops) {
    if (this.props.account !== nextprops.account) {
      this.setState(
        {
          tiles: FinancialStoriesBL.getTiles(
            AccountsStore.getAccountDetail(nextprops.account)
          ),
        },
        () => {
          this.state.tiles.length > 1 &&
            FinancialStoriesActionCreator.getFSConnection(nextprops.account);
        }
      );
    }
  }
  componentWillUnmount() {
    FinancialStoriesStore.removeChangeListener(this.onStoreChange);
    ProjectionStore.removeChangeListener(this.onProjectionStoreChange);
  }
  onStoreChange() {
    this.setState({
      showError: FinancialStoriesStore.getErrorFlag(),
    });
  }
  onProjectionStoreChange() {
    this.setState({
      projectionStatus: ProjectionStore.getStatusOfId(
        AccountsStore.getAccount()
      ),
    });
  }
  onTileClick(id) {
    switch (id) {
      case 'savingspot':
        SavingsPotsStore.getMoveMoneyAccountIndex(this.props.account);
        SavingPotsActionCreator.saveNavigationReference('WEB-ACCOUNT-DETAILS');
        InternetBankingActions.navigateToWebTask('WEB-OPEN-SAVING-POTS');
        break;
      case 'microTransactions':
        if (
          FinancialStoriesStore.getTileLoader(id) &&
          !FinancialStoriesStore.getTileError(id)
        ) {
          FinancialStoriesActionCreator.setTileType('microTransactions');
          InternetBankingActions.navigateToWebTask(
            'WEB-OPEN-FINANCIAL_STORIES'
          );
        }
        break;
      case 'cashpoint':
        if (
          FinancialStoriesStore.getTileLoader(id) &&
          !FinancialStoriesStore.getTileError(id)
        ) {
          FinancialStoriesActionCreator.setTileType('cashpoint');
          InternetBankingActions.navigateToWebTask(
            'WEB-OPEN-FINANCIAL_STORIES'
          );
        }
        break;
      case 'insAndOuts':
        if (
          FinancialStoriesStore.getTileLoader(id) &&
          !FinancialStoriesStore.getTileError(id)
        ) {
          FinancialStoriesActionCreator.setTileType('insAndOuts');
          InternetBankingActions.navigateToWebTask(
            'WEB-OPEN-FINANCIAL_STORIES'
          );
        }
        break;
      case 'projections':
        const projectionStatus = ProjectionStore.getStatusOfId(
          AccountsStore.getAccount()
        );
        if (!isVM()) {
          if (projectionStatus === 200) {
            ProjectionStore.setCancelButtonFlag(true);
            ProjectionStore.setDemoHeaderFlag(true);
            ProjectionStore.setPageMode('wheel');
            ProjectionStore.setOverdraftAmountData(
              AccountsStore.getAccountDetail(AccountsStore.getAccount())
            );
          } else if (projectionStatus === 404) {
            ProjectionStore.setCancelButtonFlag(false);
            ProjectionStore.setDemoHeaderFlag(false);
            ProjectionStore.setPageMode('demo');
          }
          InternetBankingActions.navigateToWebTask('WEB-PROJECTIONS');
        }
        break;
      default:
        break;
    }
  }
  getTilesData() {
    const fsDataList = [];
    _.map(this.state.tiles, (tile) => {
      switch (tile) {
        case 'savingspot':
          const tileData = FinancialStoriesBL.getTileData(tile);
          tileData.text = this.props.content.savingspotTileText;
          tileData.btnLabel = this.props.content.savingspotTileBtnLabel;
          fsDataList.push(tileData);
          break;
        case 'projections':
          if (!isVM()) {
            const tileData5 = {};
            tileData5.alt = 'Slinky Image';
            tileData5.image = '../images/bow/projection.png';
            tileData5.id = 'projections';
            tileData5.text = this.props.tileData.title;
            tileData5.btnLabel = this.props.tileData.subTitle;
            fsDataList.push(tileData5);
          }
          break;
        case 'microTransactions':
          const tileData1 = FinancialStoriesBL.getTileData(tile);
          if (FinancialStoriesStore.getTileError(tile)) {
            tileData1.text = this.props.content.fsTileErrorHeading;
            tileData1.btnLabel = this.props.content.fsTileErrorButtonLabel;
          } else {
            const fsDataMicroTransaction =
              FinancialStoriesStore.getMicroTransactions(
                this.props.account,
                moment().format('YYYY-MM')
              );
            let text1 = '';
            if (
              fsDataMicroTransaction &&
              fsDataMicroTransaction.sumAmount !== 0
            ) {
              text1 = this.props.content.micro_headerTextCurrentMonthWithSum;
              text1 = _.replace(
                text1,
                '{sum}',
                NumberUtils.appendCurrency(
                  '{}',
                  fsDataMicroTransaction.sumAmount * -1
                )
              );
            } else {
              text1 = this.props.content.micro_headerTextCurrentMonth;
            }
            tileData1.text = `${text1} this month.`;
            tileData1.btnLabel = this.props.content.fsCloserLook;
          }
          fsDataList.push(tileData1);
          break;
        case 'cashpoint':
          const tileData2 = FinancialStoriesBL.getTileData(tile);
          if (FinancialStoriesStore.getTileError(tile)) {
            tileData2.text = this.props.content.fsTileErrorHeading;
            tileData2.btnLabel = this.props.content.fsTileErrorButtonLabel;
          } else {
            const fsDataCashpoint = FinancialStoriesStore.getCashpoint(
              this.props.account,
              moment().format('YYYY-MM')
            );
            let text2 = '';
            if (fsDataCashpoint && fsDataCashpoint.sumAmount !== 0) {
              text2 = this.props.content.cashpoint_headerTextCurrentMonthSum;
              text2 = _.replace(
                text2,
                '{sum}',
                NumberUtils.appendCurrency('{}', fsDataCashpoint.sumAmount * -1)
              );
            } else {
              text2 = this.props.content.cashpoint_headerTextCurrentMonth;
            }
            tileData2.text = `${text2} this month.`;
            tileData2.btnLabel = this.props.content.fsCloserLook;
          }
          fsDataList.push(tileData2);
          break;
        case 'insAndOuts':
          const tileData3 = FinancialStoriesBL.getTileData(tile);
          if (FinancialStoriesStore.getTileError(tile)) {
            tileData3.text = this.props.content.fsTileErrorHeading;
            tileData3.btnLabel = this.props.content.fsTileErrorButtonLabel;
          } else {
            const fsData = FinancialStoriesStore.getInsAndOuts(
              this.props.account,
              moment().format('YYYY-MM')
            );
            let text3 = '';
            if (fsData && fsData.sumAmount < 0) {
              text3 =
                this.props.content.inAndOut_headerTextCurrentMonthNegativeSum;
              text3 = _.replace(
                text3,
                '{sum}',
                NumberUtils.appendCurrency('{}', fsData.sumAmount * -1)
              );
            } else if (fsData && fsData.sumAmount > 0) {
              text3 =
                this.props.content.inAndOut_headerTextCurrentMonthPositiveSum;
              text3 = _.replace(
                text3,
                '{sum}',
                NumberUtils.appendCurrency('{}', fsData.sumAmount)
              );
            } else {
              text3 = this.props.content.inAndOut_headerTextCurrentMonth;
            }
            tileData3.text = `${text3} this month.`;
            tileData3.btnLabel = this.props.content.fsCloserLook;
          }
          fsDataList.push(tileData3);
          break;
        default:
          break;
      }
    });
    return fsDataList;
  }
  closeErrorPopup() {
    FinancialStoriesActionCreator.resetErrorFlag();
  }
  render() {
    return (
      <div>
        {this.state.showError ? (
          <ErrorPopUpComponent
            error={FinancialStoriesStore.getError()}
            closeErrorPopup={this.closeErrorPopup}
          />
        ) : (
          ''
        )}
        <Slide
          {...this.props}
          onTileClick={this.onTileClick}
          slides={this.getTilesData()}
          lazyLoad={FinancialStoriesStore.getLoader()}
        />
      </div>
    );
  }
}
FinancialStoriesComponent.propTypes = {
  content: PropTypes.object,
  account: PropTypes.string,
  tileData: PropTypes.object,
};

FinancialStoriesComponent.defaultProps = {
  content: '',
};

export default FinancialStoriesComponent;
